import React, { useEffect, useRef } from 'react';
import './StoryDeleteDrawer.css';

export default function StoryDeleteDrawer({
  isOpen,
  onClose,
  onConfirm,
  canDelete = true,
}) {
  const sheetRef = useRef(null);

  // Close on ESC
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="deletestory-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Delete story confirmation"
      onClick={onClose} // tap outside to close
    >
      <div
        className="deletestory-sheet"
        ref={sheetRef}
        onClick={(e) => e.stopPropagation()} // keep taps inside the sheet here
      >
        <div className="deletestory-grabber" aria-hidden />

        <div className="deletestory-header">
          <h3>Delete Story</h3>
        </div>

        <div className="deletestory-body">
          {canDelete ? (
            <p>Are you sure you want to delete this story? This action cannot be undone.</p>
          ) : (
            <p className="deletestory-warning">
              This story is part of a legacy multi-item post. Deleting it would remove the entire
              story set. Deletion is disabled here.
            </p>
          )}
        </div>

        <div className="deletestory-footer">
          <button className="deletestory-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className={`deletestory-confirm ${!canDelete ? 'disabled' : ''}`}
            onClick={() => canDelete && onConfirm?.()}
            disabled={!canDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
